import { render, staticRenderFns } from "./iconDollar.vue?vue&type=template&id=9e32a3a6&scoped=true"
import script from "./iconDollar.vue?vue&type=script&setup=true&lang=js"
export * from "./iconDollar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./iconDollar.vue?vue&type=style&index=0&id=9e32a3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e32a3a6",
  null
  
)

export default component.exports